
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'main': {'width': `100%`,'minHeight': `100vh`,'alignItems': `center`,'justifyContent': `center`,'display': `flex`,},'content': {'display': `flex`,'justifyContent': `space-between`,'width': `80%`,'height': `100%`,},'info': {'display': `flex`,'flexDirection': `column`,'justifyContent': `space-between`,'width': `50%`,},
        
      };
    };
  